<section>
  <app-cp-compare-graph-header></app-cp-compare-graph-header>
  <app-cp-compare-graph-legend></app-cp-compare-graph-legend>
  <app-cp-compare-graph></app-cp-compare-graph>
</section>

